import { useRequest } from 'ahooks';
import { Button, Layout, Space, Spin } from 'antd';
import { loginController } from '../api';

function isWeChat() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  // @ts-ignore
  if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

const cdnURL = ((w: Window) => {
  return `${w.location.protocol}//${w.location.host}/app`;
})(window);

export default function AppDownload() {
  const inWechat = isWeChat();

  const { data, loading } = useRequest(() => {
    return loginController.getAppDownloadConfig();
  });

  return (
    <Layout>
      <Layout.Content style={{ height: '100vh' }}>
        <div style={{ textAlign: 'center', marginTop: 100 }}>
          <h1>下载APP</h1>
          {inWechat && <p>请使用手机浏览器打开</p>}
          <Spin spinning={loading}>
            <Space direction="vertical">
              {data?.apkName ? (
                <Button type="link" href={`${cdnURL}/new/${data?.apkName}`}>
                  点击下载新版 app
                </Button>
              ) : (
                <>无 app</>
              )}
            </Space>
          </Spin>
        </div>
      </Layout.Content>
    </Layout>
  );
}
